module.exports = __webpack_public_path__ + "static/media/Phone_Icon.e6ebd3fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/footer/Phone_Icon.png
// module id = 1561
// module chunks = 0